import { CSSProperties } from 'react';

//* 부고장 헤더 배경의 단일 출처 — 기본 헤더(ObituaryHeader)와 종교 테마 헤더(ObituaryThemedHeader)가 모두 이 style을 쓴다.
//* 색 값은 여기 없고 src/index.css의 CSS 변수(--obituary-header-*)에 테마 클래스(.Default/.Preed/.DaeMyung/.Dark)별로 있다.
//* - 테마 래퍼 클래스를 따르므로 가온처럼 한 빌드에 여러 상조 테마가 섞여도 상조별로 맞고, 프리드 고정 빌드도 그대로.
//* - 태넌트 라인(aplus 등)은 index.css의 변수 값만 바꾼다. 헤더 JSX에 색을 직접 쓰면 태넌트 머지 때 충돌하거나
//*   새 헤더가 develop 색을 그대로 들고 들어간다(2026-11-02 효담 종교 테마 헤더 실사고).
//* 아주 옅은 깊이감: 위가 살짝 밝고 아래로 갈수록 어두움(±4% 명도) + 상징 자리(위 가운데) 미세한 광원(2026-11-02 사용자 제안).
//* 종교 미설정 기본 헤더도 같은 배경을 쓴다(2026-11-02 사용자 결정). backgroundColor는 그라데이션 미지원 환경 폴백.
export const obituaryHeaderBackground: CSSProperties = {
  backgroundColor: 'var(--obituary-header-base)',
  backgroundImage:
    'radial-gradient(ellipse 60% 55% at 50% 0%, rgba(255,255,255,0.07), rgba(255,255,255,0) 70%), linear-gradient(180deg, var(--obituary-header-top) 0%, var(--obituary-header-base) 50%, var(--obituary-header-bottom) 100%)',
};
